import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import NativeDialog from 'app/shared-components/layout/NativeDialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import * as yup from 'yup';
import _ from '@lodash';
import { useState} from 'react';
import { useSelector } from 'react-redux';
import { selectAllOpenReferrals, selectReferralById} from 'app/store/referralsSlice';
import { selectMyOrganizationReferrals } from 'app/store/organizationReferralsSlice';
import { Link } from 'react-router-dom';
import DefaultButton from '../layout/DefaultButton';
import ReferralShareItem from 'app/shared-components/referral/ReferralShareItem';



function SelectReferralDialog({open, onSubmit, onClose, title, buttonText, textField, organizationId}) {
  const referrals = useSelector(selectAllOpenReferrals());
  const orgReferrals= useSelector(selectMyOrganizationReferrals);
  const useTextField= Boolean(textField);
  const [referralId, setReferralId]= useState();
  const [textValue, setTextValue]= useState("");
  const referral = useSelector(selectReferralById(referralId));
  const availableReferrals= organizationId ? referrals.filter((ref) => !hasExistingOrgReferral(ref))  : referrals;
  const hasReferrals = availableReferrals.length > 0;
  
  function hasExistingOrgReferral(referral){
     return orgReferrals.some((orgRef) => orgRef.organization?.id == organizationId && orgRef.referral?.id == referral.id);
  }

  function onSubmitInternal(data){
     onSubmit(referral, textValue);
     onClose();
  }


  return (
    <NativeDialog
      onClose={onClose}
      open={open}
      width="400px"
    >
      <AppBar position="static" color="secondary" elevation={0}>
	      <Toolbar className="flex w-full">
	        <Typography variant="subtitle1" color="inherit">
	          {title}
	        </Typography>
	      </Toolbar>
	    </AppBar>
	  
          <DialogContent classes={{ root: 'p-16 pb-0' }}>
            <div className="mb-32">

            {hasReferrals  ?
              <div className="flex flex-col w-full">
                
                 {useTextField && 
                   <TextField label={textField} value={textValue} multiline rows={3}
                              className="w-full"
                              onChange={(event) => {setTextValue(event.target.value); }}
                   />
                 }
                 
                 {referral ?   
                    <Box className="relative mt-10">
            				   <ReferralShareItem referral={referral} />
            		    </Box>
          		            :
          		    <>
          		      {availableReferrals.map((ref) => 
          		         <div key={ref.id} className="flex flex-row border-2 rounded-md align-center justify-center items-center p-6 my-12 w-full">
          		           <div className="flex grow">
            		           <Typography className="" color="secondary">
                	          {ref.summary}
                	         </Typography>
              	        </div>
              	        <DefaultButton text="Select" primary onClick={() => setReferralId(ref.id)}/>
          		         </div>
          		      )}
          		    </>
                  }  
	            </div>
	                        :
	             <div className="px-32">
				         <Typography className="text-xl" >
      	          You have no open referrals to share. You can create referrals
      	          <Link className="ml-4" to="/apps/referrals">here</Link>. 
      	        </Typography>
	            </div>
            }
            
	        </div>

          </DialogContent>

          <DialogActions className="flex flex-col sm:flex-row sm:items-center justify-between py-16 sm:py-24 px-24">
            <div className="flex items-center space-x-8 mt-16 sm:mt-0">
			        <DefaultButton text="Cancel" onClick={onClose} />
			        <DefaultButton text="Change" primary onClick={() => setReferralId(null)} 
			                       disabled={ !referral } /> 
              <DefaultButton text={buttonText} onClick={onSubmitInternal}
	              disabled={ !hasReferrals || !referral || (useTextField && !textValue) }
	              />
	             
            </div>
          </DialogActions>
    </NativeDialog>
  );
}

export default SelectReferralDialog;
